module.exports = __webpack_public_path__ + "05_short_black.5c57251e.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/mom/layer5/05_short_black.png
// module id = XlUd
// module chunks = 0